<template>
  <div class="columnBox">
    <van-form ref="ruleFormRef" label-width="120px">
      <van-cell-group>
        <van-field v-model="state.detailObj.task_name" label="任务名称" name="task_name" readonly/>
        <van-field v-model="state.detailObj.parent_task_name" label="父任务" name="parent_task_name" readonly/>
        <van-field v-model="state.detailObj.priority_level_name" label="优先级" readonly/>
        <van-field v-model="state.detailObj.assign_emp_name" label="指派人" name="assign_emp_name" readonly/>
        <van-field v-model="state.detailObj.responsible_emp_name" label="负责人" name="responsible_emp_name" readonly/>
        <van-field v-model="state.detailObj.verification_emp_name" label="验收人" name="responsible_emp_name" readonly/>
        <van-field v-model="state.detailObj.task_category_name" label="专题" readonly/>
        <van-field v-model="state.detailObj.plant_time" label="任务规划" readonly/>
        <van-field v-model="state.detailObj.team_name" label="团队" readonly/>
        <van-field v-model="state.detailObj.actual_start_time" label="实际开始时间" readonly/>
        <van-field v-model="state.detailObj.actual_end_time" label="实际完成时间" readonly/>
        <van-field v-model="state.detailObj.actual_duration" label="实际工时" name="actual_duration" readonly/>
        <van-field v-model="state.detailObj.task_percentage" label="进度百分比" name="task_percentage" readonly/>
        <van-field v-model="state.detailObj.tag" autosize label="标签" name="tag" readonly rows="1"
                   type="textarea"/>
        <van-field v-model="state.detailObj.remark" autosize label="备注" name="remark" readonly rows="1"
                   type="textarea"/>
        <van-field v-model="state.detailObj.task_description" autosize label="任务说明" name="task_description" readonly
                   rows="3" type="textarea"/>
        <van-field v-model="state.detailObj.progress_description" autosize label="进度说明" name="progress_description"
                   readonly rows="3" type="textarea"/>
        <van-field v-model="state.detailObj.complete_description" autosize label="完成说明" name="complete_description"
                   readonly rows="3" type="textarea"/>
        <van-field autosize label="附件" name="附件">
          <template #input>
            <FileListComp :fileList="state.fileList" :isTask="true"/>
          </template>
        </van-field>
      </van-cell-group>
    </van-form>
    <div class="bottom-button-bar">
      <van-button type="primary" @click="finishTask()">完成</van-button>
    </div>
  </div>
</template>
<script setup>
import {onMounted, reactive, ref} from "vue";
import {GetTaskDataById, GetTeamInfoByCurrentEmpId} from "@/api/Tmg/myTask";
import {useRoute, useRouter} from "vue-router";
import {Toast} from "vant";
import moment from "moment";
import axios from "axios";
import {nextTick} from "@vue/runtime-core";
import FileListComp from "@/components/FileListComp.vue";
import {isImage} from "@/utils/utils";
import {DownLoadFiles} from "../../api/oaApi";
import {blobToBase64, getFileType} from "../../utils/utils";
import {UpdateFinishStatus} from "../../api/Tmg/myTask";
import * as dd from 'dingtalk-jsapi';

const route = useRoute()
const router = useRouter()
const ruleFormRef = ref()
const state = reactive({
  parent_task_name: "",//父任务
  queryParams: {
    id: "",
  },
  detailObj: {}, // 详情对象
  fileList: [], // 文件列表
  teamInfo: [],//团队信息
})
// 获取任务详情
const getTaskDataById = async () => {
  try {
    await nextTick()
    // 获取团队信息
    const teamRes = await GetTeamInfoByCurrentEmpId()
    state.teamInfo = teamRes.data
    const res = await GetTaskDataById({id: state.queryParams.id})
    state.detailObj = res.data.result[0]
    state.detailObj.dingDingTaskId = res.data.result[0].dingding_task_id
    state.detailObj.responsible_emp_name = res.data.result[0].responsible_emp_code + '-' + res.data.result[0].responsible_emp_name
    state.detailObj.verification_emp_name = res.data.verificationResult
        .map(item => `${item.emp_code}-${item.emp_name}`)
        .join('、');
    state.detailObj.plant_time = moment(state.detailObj.plan_start_time).format('YYYY-MM-DD') + "  -  " + moment(state.detailObj.plan_end_time).format('YYYY-MM-DD')

    state.detailObj.actual_start_time = state.detailObj.actual_start_time ? moment(state.detailObj.actual_start_time).format('YYYY-MM-DD') : ''
    state.detailObj.actual_end_time = state.detailObj.actual_end_time ? moment(state.detailObj.actual_end_time).format('YYYY-MM-DD') : ''

    let findTeam = state.teamInfo.find(t => t.id === state.detailObj.team_id)
    if (findTeam) {
      state.detailObj.team_name = findTeam.team_name
    } else {
      state.detailObj.team_name = ''
    }
    state.detailObj.task_percentage = state.detailObj.task_percentage + "%"
    await getFiles(state.detailObj.attachment_id === null ? '' : state.detailObj.attachment_id)
  } catch (err) {
    Toast.fail('加载失败，请重试')
  } finally {
    state.loading.clear()
  }
}
// 获取附件文件列表
const getFiles = async (data) => {
  // 处理附件
  state.fileList = []
  const list = data.split(',')
  const fileRes = await axios({
    method: 'POST',
    url: '/oa_portal/oa/portal/Common/GetFilelist',
    headers: {Authorization: localStorage.getItem('Token')},
    data: list,
  })
  const tasks = fileRes.data.data.map(async (item) => {
    const fileItem = {
      id: item.id,
      name: item.file_name,
      size: item.file_size,
      type: item.extension.slice(1),
    };
    state.fileList.push(fileItem);

    // 构造 fileLists 中结构
    const result = {
      file: {
        name: item.file_name,
        id: item.id,
        type: getFileType(item.file_name),
      },
    };
    // 如果是图片，尝试下载 base64 内容
    if (isImage(item.extension.slice(1))) {
      const res = await DownLoadFiles({attachment_id: item.id});
      result.content = await blobToBase64(res);
    }

    return result;
  });
  // 并发执行所有任务
  await Promise.all(tasks);
}
//完成
const finishTask = () => {
  let list = {
    taskId: state.detailObj.id,
    planStartTime: state.detailObj.plan_start_time,
    planEndTime: state.detailObj.plan_end_time,
    dingDingTaskId: state.detailObj.dingDingTaskId,
    responsible_emp_id: state.detailObj.responsible_emp_id
  }
  UpdateFinishStatus(list).then((res) => {
    if (res.success) {
      Toast.success(res.msg)
      dd.biz.navigation.close({
        onSuccess: function () {
        },
        onFail: function (err) {
        }
      });
    } else {
      Toast.fail(res.msg)
    }
  })
      .catch((error) => {
        Toast.fail('更新状态异常：' + error)
      });
}
onMounted(() => {
  state.loading = Toast.loading({
    message: '加载中...',
    forbidClick: true,
    duration: 0
  });
  const {id} = route.query
  state.queryParams.id = id
  getTaskDataById()
})
</script>
<style lang="scss" scoped>
:deep(.van-cell) {
  flex-direction: column;
}

.headerBox {
  background: #fff;
  padding: 10px 15px;

  p {
    margin: 5px 0;
  }
}

.contentBox {
  padding-bottom: 55px;
}

.columnBox {
  margin: 5px;
  border-radius: 8px;
  overflow: hidden;
  padding-bottom: 60px;
}

.slider {
  width: 100%;
  padding: 0 10px;
}

.custom-button {
  width: 26px;
  color: #fff !important;
  font-size: 10px;
  line-height: 18px;
  text-align: center;
  background-color: var(--van-primary-color);
  border-radius: 100px;
  -webkit-text-fill-color: #fff;
}

/* 底部按钮区域样式 */
.bottom-button-bar {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  padding: 12px 16px;
  background-color: #fff;
  box-shadow: 0 -2px 8px rgba(0, 0, 0, 0.05);
  display: flex;
  gap: 10px;
  z-index: 999;
  border-top: 1px solid #f2f2f2;
}

.bottom-button-bar .van-button {
  flex: 1;
  border-radius: 8px;
}

.verify-card {
  background-color: #fff;
  border-radius: 8px;
  padding: 12px;
  margin-bottom: 10px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}

.verify-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 6px;
  font-size: 12px;
}

.verify-name {
  color: #333;
}

.verify-desc {
  font-size: 12px;
  color: #666;
  line-height: 1.4;
}

</style>